(() => {
  if (customElements.get('dope-paddle-shape-picker')) return;
  class DopePaddleShapePicker extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.addEventListener('keydown', event => this.onKeydown(event), options);
      this.addEventListener('change', event => this.onSelection(event), options);
      this.addEventListener('click', event => {
        if (event.target.matches('input[type="radio"]')) this.onSelection(event);
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      const active = document.activeElement;
      const previous = active?.closest('dope-paddle-shape-picker');
      const nativePicker = this.closest('variant-picker');
      const field = this.getAttribute('data-paddle-field');
      const previousField = previous?.getAttribute('data-paddle-field');
      const matchingField = nativePicker && Array.from(nativePicker.querySelectorAll('dope-paddle-shape-picker'))
        .find(picker => picker.getAttribute('data-paddle-field') === previousField);
      if (previous && previous !== this && nativePicker?.id && nativePicker.id === previous.closest('variant-picker')?.id
        && (field === previousField || (field === 'shape' && !matchingField))) {
        const {signal} = this.controller;
        queueMicrotask(() => {
          if (!signal.aborted && this.isConnected && document.activeElement === active) this.summary.focus({preventScroll: true});
        });
      }
    }

    disconnectedCallback() { this.controller?.abort(); }

    get details() { return this.querySelector('details'); }
    get summary() { return this.querySelector('summary'); }
    get choices() { return Array.from(this.querySelectorAll('input[type="radio"]:not(:disabled), a[href]')); }

    close(focus = false) {
      this.details.open = false;
      if (focus) this.summary.focus({preventScroll: true});
    }

    onSelection(event) {
      const input = event.target;
      if (!input.matches('input[type="radio"]') || input.disabled || !input.checked) return;
      const label = input.labels[0];
      const selected = this.querySelector('[data-shape-summary]');
      selected.replaceChildren(...Array.from(label.childNodes, child => child.cloneNode(true)));
      this.syncCoreLinks(input.value);
      this.close(true);
    }

    syncCoreLinks(shape) {
      const core = this.closest('variant-picker')?.querySelector('[data-paddle-core-field]');
      if (!core) return;
      const pending = core.getAttribute('data-core-shape') !== shape;
      if (pending) core.setAttribute('aria-busy', 'true');
      else core.removeAttribute('aria-busy');
      // Until native HTML arrives, old sibling URLs still belong to the
      // rendered Shape. Remove navigation rather than guessing a variant ID.
      core.querySelectorAll('a').forEach(link => {
        if (pending && link.hasAttribute('href')) {
          link.setAttribute('data-core-href', link.getAttribute('href'));
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
        } else if (!pending && link.hasAttribute('data-core-href')) {
          link.setAttribute('href', link.getAttribute('data-core-href'));
          link.removeAttribute('data-core-href');
          link.removeAttribute('aria-disabled');
        }
      });
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.details.open) {
        event.preventDefault();
        event.stopPropagation();
        this.close(true);
        return;
      }
      if (event.key === 'Enter' && event.target.matches('input[type="radio"]')) {
        event.preventDefault();
        event.target.click();
        return;
      }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      const atSummary = event.target === this.summary;
      if (!atSummary && !this.details.open) return;
      const choices = this.choices;
      if (!choices.length) return;
      event.preventDefault();
      this.details.open = true;
      let index = choices.indexOf(event.target);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = choices.length - 1;
      else if (atSummary) index = event.key === 'ArrowUp' ? choices.length - 1 : 0;
      else index = (index + (event.key === 'ArrowUp' ? -1 : 1) + choices.length) % choices.length;
      choices[index].focus({preventScroll: true});
    }
  }
  customElements.define('dope-paddle-shape-picker', DopePaddleShapePicker);
})();
